// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 PUT /api/visit3 */
export async function visit3ControllerUpdate(
	body: API.Visit3UpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/visit3', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/visit3/${param0} */
export async function visit3ControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit3ControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.Visit3ViewResponse>(`/api/visit3/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/visit3/${param0} */
export async function visit3ControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit3ControllerCreateParams,
	body: API.Visit3CreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/visit3/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}
